export const loadScript = (
  url: string,
  attributes: Record<string, string> = {},
): Promise<void> => {
  // eslint-disable-next-line @trello/no-query-selector
  const head = document.querySelector('head');
  if (head) {
    return new Promise((resolve, reject) => {
      const scriptEl = document.createElement('script');
      scriptEl.async = true;
      scriptEl.src = url;
      scriptEl.onload = () => resolve();
      scriptEl.onerror = reject;
      Object.entries(attributes).forEach(([key, value]) => {
        scriptEl.setAttribute(key, value);
      });

      return head.appendChild(scriptEl);
    });
  } else {
    return Promise.reject('No head found');
  }
};
